enum Connectivity
{
	WiFi = 1,
	LAN = 2,
	Mobile = 3,
	None = 4
}

export default Connectivity;